import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Location } from '@angular/common';

type Crumb = { label: string; url?: string };

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent {
  show = false;
  crumbs: Crumb[] = [];

  private currentUrl = '';
  private prevUrl: string | null = null;
  private readonly backFallback = '/dashboard'; // Manage Account landing

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => {
        this.prevUrl = this.currentUrl || null;
        this.currentUrl = e.urlAfterRedirects;
        this.build();
      });
    this.build();
  }

  private build() {
    // deepest child
    let ar: ActivatedRoute = this.route;
    while (ar.firstChild) ar = ar.firstChild;

    const data = ar.snapshot.data || {};
    if (data['bcGroup'] === 'manage') {
      // Accept either:
      //  - bcTrail: Crumb[] (preferred for deep pages)
      //  - breadcrumb: string (legacy single label)
      let trail: Crumb[] = [];

      if (Array.isArray(data['bcTrail'])) {
        trail = (data['bcTrail'] as any[]).map(item =>
          typeof item === 'string' ? { label: item } : item
        );
      } else {
        const label =
          data['breadcrumb'] ||
          this.titleFromPath(ar.snapshot.routeConfig?.path || '');
        trail = [{ label }];
      }

      this.show = true;
      this.crumbs = [
        { label: 'Home', url: '/' },
        { label: 'Manage Account', url: this.backFallback },
        ...trail
      ];
    } else {
      this.show = false;
      this.crumbs = [];
    }
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigateByUrl(this.backFallback);
    }
  }

  private titleFromPath(path: string): string {
    return path.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
}
